import React from 'react';

import AdvancedIcon from '@core/assets/icons/proficiency-advanced.svg';
import IntermediateIcon from '@core/assets/icons/proficiency-intermediate.svg';
import BeginnerIcon from '@core/assets/icons/proficiency-beginner.svg';

import classes from './ProficiencyBadge.module.scss';

const ProficiencyBadge = ({ proficiency }) => {

    if (proficiency === 'advanced')
        return <AdvancedIcon />;
    else if (proficiency === 'intermediate')
        return <IntermediateIcon />
    else if (proficiency === 'beginner')
        return <BeginnerIcon />
};

export default ProficiencyBadge;